import { render, staticRenderFns } from "./ImportDataModal.vue?vue&type=template&id=2108ec8a&scoped=true&"
import script from "./ImportDataModal.vue?vue&type=script&lang=js&"
export * from "./ImportDataModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportDataModal.vue?vue&type=style&index=0&id=2108ec8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108ec8a",
  null
  
)

export default component.exports